export const GET_AUDIO_GENERATION_QUEUE_STATS = `audioGenerationQueue/GET_AUDIO_GENERATION_QUEUE_STATS`;
export const SET_AUDIO_GENERATION_QUEUE_STATS = `audioGenerationQueue/SET_AUDIO_GENERATION_QUEUE_STATS`;
export const GET_ABBREVIATIONS_QUEUE_STATS = `audioGenerationQueue/GET_ABBREVIATIONS_QUEUE_STATS`;
export const SET_ABBREVIATIONS_QUEUE_STATS = `audioGenerationQueue/SET_ABBREVIATIONS_QUEUE_STATS`;
export const UPDATE_AUDIO_GENERATION_JOBS = `audioGenerationQueue/UPDATE_AUDIO_GENERATION_JOBS`;
export const UPDATE_ABBREVIATIONS_JOBS = `audioGenerationQueue/UPDATE_ABBREVIATIONS_JOBS`;
